import { Component, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FirebaseAuthService } from '../../../shared/firebase-auth.service';

/** Error page displayed when the authenticated user does not have permission to access the requested project. */
@Component({
  selector: 'app-no-access',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
})
export class NoAccessComponent {
  private firebaseAuthService = inject(FirebaseAuthService);

  signOut(): void {
    this.firebaseAuthService.signOut();
  }
}
